import { createApp } from 'vue'
import {
	ElButton,
	ElDialog,
	ElDropdown,
	ElDropdownItem,
	ElDropdownMenu,
	ElEmpty,
	ElForm,
	ElFormItem,
	ElInput,
	ElProgress,
	ElSkeleton,
	ElSkeletonItem,
	ElTable,
	ElTableColumn,
	ElTabPane,
	ElTabs,
	ElTag,
	ElUpload,
	ElLoading,
} from 'element-plus'
import 'element-plus/es/components/base/style/css'
import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/dialog/style/css'
import 'element-plus/es/components/dropdown/style/css'
import 'element-plus/es/components/dropdown-item/style/css'
import 'element-plus/es/components/dropdown-menu/style/css'
import 'element-plus/es/components/empty/style/css'
import 'element-plus/es/components/form/style/css'
import 'element-plus/es/components/form-item/style/css'
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/loading/style/css'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/progress/style/css'
import 'element-plus/es/components/skeleton/style/css'
import 'element-plus/es/components/skeleton-item/style/css'
import 'element-plus/es/components/table/style/css'
import 'element-plus/es/components/table-column/style/css'
import 'element-plus/es/components/tabs/style/css'
import 'element-plus/es/components/tab-pane/style/css'
import 'element-plus/es/components/tag/style/css'
import 'element-plus/es/components/upload/style/css'
import App from './App.vue'
import router from './router'
import { useAuth } from './auth'
import './styles.css'

const elementComponents = [
	ElButton,
	ElDialog,
	ElDropdown,
	ElDropdownItem,
	ElDropdownMenu,
	ElEmpty,
	ElForm,
	ElFormItem,
	ElInput,
	ElProgress,
	ElSkeleton,
	ElSkeletonItem,
	ElTable,
	ElTableColumn,
	ElTabPane,
	ElTabs,
	ElTag,
	ElUpload,
]

async function bootstrap() {
	const auth = useAuth()
	await auth.initAuth()

	const app = createApp(App)
	elementComponents.forEach((component) => {
		if (component.name) app.component(component.name, component)
	})
	app.directive('loading', ElLoading.directive)
	app.use(router).mount('#app')
}

void bootstrap()

